import { AppSettings } from '../appSettings'
import { Tenant } from './models/Tenant'

export class TenantService {

  static selectedTenant: Tenant = null;

  static async getTenants(): Promise<Tenant[]> {
    try {
      const tenants = await AppSettings.get('TENANTS')

      return tenants.map((tenant) => {
        return {
          name: tenant.NAME,
          cluster: tenant.CLUSTER,
          defaultCluster: tenant.DEFAULT_CLUSTER,
          prefix: tenant.PREFIX,
          blipChatUrl: tenant.BLIP_CHAT_URL
        } as Tenant
      })
    } catch {
      return []
    }
  }

  static setSelectedTenant(tenant: Tenant): void {
    this.selectedTenant = tenant
  }

  static getSelectedTenant(): Tenant {
    return this.selectedTenant
  }

  static isTenantSelected(): boolean {
    return this.selectedTenant ? true : false
  }
}
